var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24px",
    height: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 19A1 1 0 1011 21 1 1 0 1011 19zM15 19A1 1 0 1015 21 1 1 0 1015 19zM19 19A1 1 0 1019 21 1 1 0 1019 19zM10.517 5.892L3.369 16.29c-.103.149-.163.324-.174.505l-.193 3.144c-.021.351.143.688.432.886C3.604 20.94 3.801 21 4 21c.141 0 .283-.03.416-.091L7.28 19.6c.165-.075.306-.193.408-.343l7.161-10.417L10.517 5.892zM17.346 4.553c-.035-.119-.375-1.183-1.422-1.902-1.049-.721-2.166-.656-2.287-.645-.3.024-.574.183-.745.431L11.65 4.243l4.333 2.948 1.229-1.787C17.382 5.154 17.432 4.842 17.346 4.553z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.16104c2839e3e6ebf3452a586cb0bdaf.svg";
export { ForwardRef as ReactComponent };